import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = "/_/lv-quiz"

export default new Vuex.Store({
  
  state: {
    auth: {
      locked: true, // Set this to true in production
      hash: 'f7ec2d2600c8998dd7ebb42ea2367dc30615d60a801383b4bcb319a5b376e6aa',
    },
    quiz: {
      tally: [],
      questions: {},
      products: {},
      ignore: [],
    },
  },
  mutations: {
    unlock(state){
      this.state.auth.locked = false
    },
    resetQuiz(state){
      state.quiz.tally = []
    },
    setQuizData(state, {questions, products, ignore}){
      state.quiz.questions = questions
      state.quiz.products = products
      state.quiz.ignore = ignore.trim().split(/\n/gmi).map(s => s.trim())
    },
    tally(state, products){
      for(let sku of products){
        Vue.set(state.quiz.tally, state.quiz.tally.length, sku)
      }
    },
  },
  actions: {
    async hash(context, message) {
      const msgUint8 = new TextEncoder().encode(message)
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
      return hashHex
    },

    async getData({commit}){
      const {data: questions} = await axios.get(`${BASE_URL}/data/questions.json`)
      const {data: products} = await axios.get(`${BASE_URL}/data/products.json`)
      const {data: ignore} = await axios.get(`${BASE_URL}/data/ignore.txt`)
      console.log(`There are ${Object.keys(questions).length} questions`)
      console.log(questions)
      console.log(`There are ${Object.keys(products).length} products`)
      console.log(products)
      commit('setQuizData', {questions, products, ignore})

      // Preload images
      Object.values(questions).forEach(options => {
        Object.values(options).forEach(option => {
          const img = new Image()
          img.src = `${BASE_URL}/img/backgrounds/${option.background}`
        })
      })
      Object.values(products).forEach(product => {
        const img = new Image()
        img.src = `${BASE_URL}/img/products/${product.img_id}`
      })
    },
  },
  getters: {
    topProducts(state) {
      let count = {}

      for(let sku of state.quiz.tally){
        if(!state.quiz.ignore.includes(sku)){
          if(count[sku] > 0) count[sku]++
          else count[sku] = 1
        }
      }

      return Object.entries(count).sort((a, b) => b[1] - a[1])
    },
  },
  modules: {
  },
})